import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'

import 'i18n'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('ai-search-app-root')
)
